import React from 'react';
import { SButton, SIcon, type SButtonProps } from '@chargebee/sting-react';

/** Default plus icon size for admin add/create controls. */
export const PLUS_ICON_SIZE = 20;

export type PlusButtonProps = SButtonProps;

/**
 * Standard add/create control: {@link SButton} with {@link SIcon} `plus`.
 *
 * Variants:
 * - `primary` (default): page toolbar CTAs (New, Add field)
 * - `primary-outline`: bordered add in forms, cards, footers
 * - `primary-ghost`: low-emphasis inline add (use sparingly)
 */
export const PlusButton = React.forwardRef<HTMLButtonElement, PlusButtonProps>(
  ({ variant = 'primary', icon, ...props }, ref) => (
    <SButton
      ref={ref}
      variant={variant}
      icon={icon ?? <SIcon name="plus" size={PLUS_ICON_SIZE} />}
      {...props}
    />
  )
);
PlusButton.displayName = 'PlusButton';

/**
 * Icon + label for `SButton asChild` + router `Link`. Relies on `SButton`'s
 * built-in `gap` for icon→text spacing so it matches the icon-prop `PlusButton`.
 */
export const PlusButtonLinkContent: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => (
  <>
    <SIcon name="plus" size={PLUS_ICON_SIZE} />
    {children}
  </>
);
